// import React, { useEffect, useState } from 'react';
// import { Card, CardTitle, CardBody, Button, Table } from 'reactstrap';
// import { useNavigate } from 'react-router-dom';
// import { apiService } from '../../constants/ApiService';
// import VendorBranchSelector from '../../components/VendorBranchSelector';
// import { useSelector } from 'react-redux';
// import conditionalDataLoad from '../../utils/conditionalDataLoad';
// import useVendorBranch from '../../utils/useVendorBranch';

// const WeekendList = () => {
//   const { user } = useSelector((state) => state.authState);
//   const navigate = useNavigate();

//   const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
//     useVendorBranch(user);

//   const [errorMessage, setErrorMessage] = useState({});
//   const [weekendList, setWeekendList] = useState([]);

//   // ✅ Same like FeeHead: start empty
//   const [selectionData, setSelectionData] = useState({
//     vendor_id: '',
//     branch_id: '',
//   });

//   const onHandleAdd = () => {
//     navigate('/save-weekend');
//   };

//   const onHandleEdit = (id) => {
//     const selected = weekendList.find((x) => x.id === id);
//     navigate('/save-weekend', { state: { ...(selected || {}) } });
//   };

//   const GetWeekendList = async () => {
//     try {
//       const vendorId = selectionData.vendor_id || '';
//       const branchId = selectionData.branch_id || '';

//       const res = await apiService.get(
//         `api/HolidayMaster/GetAllWeekend?vendorId=${vendorId}&branchId=${branchId}`
//       );

//       if (res?.status === true) {
//         setWeekendList(res.data || []);
//       } else {
//         alert(res?.message || 'Failed');
//       }
//     } catch (e) {
//       console.error(e);
//       alert('Something went wrong');
//     }
//   };

//   useEffect(() => {
//     const canLoad = conditionalDataLoad({
//       hasMultiBranch,
//       hasSingleBranch,
//       isSuperAdmin,
//       isAdmin,
//       vendorId: selectionData.vendor_id,
//       branchId: selectionData.branch_id,
//     });

//     if (canLoad) {
//       GetWeekendList();
//     }
//   }, [selectionData.vendor_id, selectionData.branch_id]);

//   return (
//     <>
//       <div className='text-right mb-2'>
//         <Button color='primary' onClick={onHandleAdd}>
//           <i className='bi bi-plus-circle' /> Add Weekend
//         </Button>
//       </div>

//       <VendorBranchSelector
//         user={user}
//         selectionData={selectionData}
//         setSelectionData={setSelectionData}
//         errorMessage={errorMessage}
//         accessButton={true}
//       />

//       <Card className='card-box pd-20 mb-20'>
//         <CardTitle className='p-3 mb-0'>
//           <i className='bi bi-calendar-week mr-2' /> Weekend Settings
//         </CardTitle>

//         <CardBody>
//           <Table striped hover responsive>
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>Edit</th>
//                 <th>Day</th>
//                 <th>Name of the Day</th>
//                 <th>Academic Year</th>
//               </tr>
//             </thead>
//             <tbody>
//               {weekendList.length > 0 ? (
//                 weekendList.map((x, i) => (
//                   <tr key={x.id}>
//                     <td>{i + 1}</td>
//                     <td>
//                       <i
//                         className='bi bi-pencil text-primary'
//                         style={{ cursor: 'pointer' }}
//                         onClick={() => onHandleEdit(x.id)}
//                       />
//                     </td>
//                     <td>
//                       {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][
//                         Number(x.day_of_week)
//                       ] || ''}
//                     </td>
//                     <td>{x.name_of_the_day}</td>
//                     <td>
//                       {x.academic_year
//                         ? new Date(x.academic_year).getFullYear()
//                         : ''}
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan='5' className='text-center'>
//                     No data available
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </Table>
//         </CardBody>
//       </Card>
//     </>
//   );
// };

// export default WeekendList;
//SignalR
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Card, CardTitle, CardBody, Button, Table } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import { useSelector } from 'react-redux';
import conditionalDataLoad from '../../utils/conditionalDataLoad';
import useVendorBranch from '../../utils/useVendorBranch';
import {
  createAppConnection,
  joinModuleGroup,
  leaveModuleGroup,
  subscribeRealtimeUpdate,
  unsubscribeRealtimeUpdate,
} from '../../utils/signalRService';

const MODULE_NAME = 'Weekend';

const WeekendList = () => {
  const { user } = useSelector((state) => state.authState);
  const navigate = useNavigate();

  const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
    useVendorBranch(user);

  const [errorMessage, setErrorMessage] = useState({});
  const [weekendList, setWeekendList] = useState([]);

  const [selectionData, setSelectionData] = useState({
    vendor_id: '',
    branch_id: '',
  });

  const currentGroupRef = useRef({
    module: null,
    vendorId: null,
    branchId: null,
  });

  const onHandleAdd = () => {
    navigate('/save-weekend');
  };

  const onHandleEdit = (id) => {
    const selected = weekendList.find((x) => x.id === id);
    navigate('/save-weekend', { state: { ...(selected || {}) } });
  };

  const GetWeekendList = useCallback(async () => {
    try {
      const vendorId = selectionData.vendor_id || '';
      const branchId = selectionData.branch_id || '';

      const res = await apiService.get(
        `api/HolidayMaster/GetAllWeekend?vendorId=${vendorId}&branchId=${branchId}`,
      );

      if (res?.status === true) {
        setWeekendList(res.data || []);
      } else {
        alert(res?.message || 'Failed');
      }
    } catch (e) {
      console.error(e);
      alert('Something went wrong');
    }
  }, [selectionData.vendor_id, selectionData.branch_id]);

  useEffect(() => {
    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: selectionData.vendor_id,
      branchId: selectionData.branch_id,
    });

    if (canLoad) {
      GetWeekendList();
    } else {
      setWeekendList([]);
    }
  }, [
    selectionData.vendor_id,
    selectionData.branch_id,
    hasMultiBranch,
    hasSingleBranch,
    isSuperAdmin,
    isAdmin,
    GetWeekendList,
  ]);

  useEffect(() => {
    let mounted = true;

    const setupSignalR = async () => {
      try {
        await createAppConnection();

        const vendorId = selectionData.vendor_id || 0;
        const branchId = selectionData.branch_id || 0;

        const prev = currentGroupRef.current;

        if (
          prev.vendorId &&
          prev.branchId &&
          (String(prev.vendorId) !== String(vendorId) ||
            String(prev.branchId) !== String(branchId))
        ) {
          await leaveModuleGroup(prev.module, prev.vendorId, prev.branchId);
        }

        if (vendorId && branchId) {
          await joinModuleGroup(MODULE_NAME, vendorId, branchId);

          currentGroupRef.current = {
            module: MODULE_NAME,
            vendorId,
            branchId,
          };
        }

        unsubscribeRealtimeUpdate();

        await subscribeRealtimeUpdate((payload) => {
          if (!mounted) return;
          if (!payload) return;

          const isSameModule = String(payload.module || '') === MODULE_NAME;
          const isSameVendor =
            String(payload.vendorId || '') === String(vendorId || '');
          const isSameBranch =
            String(payload.branchId || '') === String(branchId || '');

          if (isSameModule && isSameVendor && isSameBranch) {
            console.log('Weekend realtime update received:', payload);
            GetWeekendList();
          }
        });
      } catch (err) {
        console.error('SignalR error:', err);
      }
    };

    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: selectionData.vendor_id,
      branchId: selectionData.branch_id,
    });

    if (canLoad) {
      setupSignalR();
    }

    return () => {
      mounted = false;
    };
  }, [
    selectionData.vendor_id,
    selectionData.branch_id,
    hasMultiBranch,
    hasSingleBranch,
    isSuperAdmin,
    isAdmin,
    GetWeekendList,
  ]);

  useEffect(() => {
    return () => {
      unsubscribeRealtimeUpdate();

      const prev = currentGroupRef.current;
      if (prev?.vendorId && prev?.branchId) {
        leaveModuleGroup(prev.module, prev.vendorId, prev.branchId).catch(
          console.error,
        );
      }
    };
  }, []);

  return (
    <>
      <div className='text-right mb-2'>
        <Button color='primary' onClick={onHandleAdd}>
          <i className='bi bi-plus-circle' /> Add Weekend
        </Button>
      </div>

      <VendorBranchSelector
        user={user}
        selectionData={selectionData}
        setSelectionData={setSelectionData}
        errorMessage={errorMessage}
        accessButton={true}
      />

      <Card className='card-box pd-20 mb-20'>
        <CardTitle className='p-3 mb-0'>
          <i className='bi bi-calendar-week mr-2' /> Weekend Settings
        </CardTitle>

        <CardBody>
          <Table striped hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Edit</th>
                <th>Day</th>
                <th>Name of the Day</th>
                <th>Academic Year</th>
              </tr>
            </thead>
            <tbody>
              {weekendList.length > 0 ? (
                weekendList.map((x, i) => (
                  <tr key={x.id}>
                    <td>{i + 1}</td>
                    <td>
                      <i
                        className='bi bi-pencil text-primary'
                        style={{ cursor: 'pointer' }}
                        onClick={() => onHandleEdit(x.id)}
                      />
                    </td>
                    <td>
                      {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][
                        Number(x.day_of_week)
                      ] || ''}
                    </td>
                    <td>{x.name_of_the_day}</td>
                    <td>
                      {x.academic_year
                        ? new Date(x.academic_year).getFullYear()
                        : ''}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan='5' className='text-center'>
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </>
  );
};

export default WeekendList;
